// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28hWN","content":"styles_content__2V-Od","tableWrap":"styles_tableWrap__2yqxb"};